import { inject, Injectable } from '@angular/core';
import { ApiContext, BACKEND_CONFIG } from '@unicup-ticketing/injection-context';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HasLinks } from '@unicup-ticketing/utils';
import { DrawState } from './draw.model';
import { RegistrationState } from '../registration/registration.model';

export interface ApiDraw extends HasLinks {
  id: string;
  displayName: string;
  state: DrawState;
}

export interface ApiDrawProfileProjection extends HasLinks {
  id: string;
  displayName: string;
  state: DrawState;
  registration: RegistrationProfilePeek;
}

export interface RegistrationProfilePeek {
  state: RegistrationState;
}

export interface ApiDrawProfileProjectionEmbeddedCollection {
  draws: ApiDrawProfileProjection[];
}

export interface ApiDrawProfileCollection {
  draws: ApiDraw[];
}

@Injectable({
  providedIn: 'root',
})
export class DrawApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl: string;

  constructor() {
    const authConfig = inject<ApiContext>(BACKEND_CONFIG);

    this.baseUrl = authConfig.baseUrl;
  }

  public getDrawCollection<T>(projection?: string): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/draws`, {
      params: this.configureProjectionParams(projection),
    });
  }

  public getDrawById<T>(drawId: string, projection: string | undefined = undefined): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/draws/${drawId}`, {
      params: this.configureProjectionParams(projection),
    });
  }

  private configureProjectionParams(projection: string | undefined = undefined): HttpParams {
    let params = new HttpParams();
    if (projection !== undefined) {
      params = params.set('proj', projection);
    }
    return params;
  }
}
